<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Edit Workstation Task Types</p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <div class="modal-card-body">

          <label class="label">Task Types</label>

          <v-checkbox 
            v-for="workStep in workSteps" 
            :value="workstationWorkStepIds.includes(workStep.id)"
            @input="toggleWorkStep(workStep.id)"
            :label="workStep.work_name"
            :key="workStep.id"/>

        </div>

        <footer class="modal-card-foot">
          <button 
            class="button is-primary" 
            @click.stop="close()">
            Done Edits
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import VCheckbox from '@/components/base/VCheckbox'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    workstation: {
      type: Object
    }
  },
  components: { 
    VCheckbox
  },
  computed: {
    ...mapState("workSteps", [
      "workSteps"
    ]),
    workstationWorkStepIds() {
      return this.workstation.workstation_steps.map(d => d.work_step_id);
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("workstations", [
      "addWorkstationWorkStep", "deleteWorkstationWorkStep"
    ]),
    ...mapActions("workSteps", ["getWorkSteps"]),
    initialize() {
      if (this.workSteps.length == 0) {
        this.getWorkSteps();
      }
    },
    addWorkStep(workStepId) {
      this.addWorkstationWorkStep({
        workstation_id: this.workstation.id,
        work_step_id: workStepId,
      })
    },
    deleteWorkStep(workstationWorkStepId) {
      this.deleteWorkstationWorkStep({
        workstationId: this.workstation.id,
        workstationWorkStepId: workstationWorkStepId,
      })
    },
    toggleWorkStep(workStepId) {
      let index = this.workstationWorkStepIds.indexOf(workStepId);
      if (index == -1) {
        this.addWorkStep(workStepId);
      } else {
        let workstationWorkStepId = this.workstation.workstation_steps.filter(
          d => d.work_step_id == workStepId
        )[0].id;
        this.deleteWorkStep(workstationWorkStepId);
      }
    },
    close() {
      this.$emit('input', false);
    }
  }
}
</script>

<style scoped>
.modal-card {
  border-radius: 6px;
}
</style>
